<template>
  <div class="advanced-techniques-list academy-container">
    <header class="advanced-techniques-list-hd">
      <div
        class="academy-hd-wrapper"
        v-scroll-animate="{
          animation: 'fadeInDown',
        }"
      >
        <h4 class="academy-hd-subTitle">狄诺尼学院</h4>
        <h2 class="academy-hd-title">快速掌握{{ productType }}，从这里开始</h2>
        <h4 class="academy-hd-subTitle">
          {{ productType }}进阶技巧，帮助你更进一步
        </h4>
        <h4 class="academy-hd-subTitle">技术支持：4000-025-828</h4>
      </div>
    </header>

    <div class="topTitle">
      <div class="flex-row">
        <div style="width: 80px">当前位置：</div>
        <div class="backBtn" @click="back">狄诺尼学院&nbsp;> &nbsp;</div>
        <div class="skillTitle" :title="productType">
          {{ productType }}进阶技巧
        </div>
      </div>
    </div>

    <div class="content">
      <div class="advancedTechniquesList">
        <div
          v-for="(item, index) in dataList"
          :key="index"
          class="advancedTechniquesCard"
          @click="openUrl(item)"
        >
          <div class="left">
            <div class="date">
              {{ item.publishDate.split("-").slice(1).join("-") }}
            </div>
            <br />
            <div class="year">
              {{ item.publishDate.split("-")[0] }}
            </div>
          </div>

          <div class="line"></div>

          <div class="text">
            <div class="title">{{ item.title }}</div>

            <div class="summary">{{ item.subtitle }}</div>
          </div>

          <img class="thumbnail" :src="item.coverUrl" alt="轮播图" />
        </div>
      </div>
    </div>
    <div
      style="margin: 0 auto; padding-bottom: 80px; width: fit-content"
      v-if="total > 0"
    >
      <Pagination
        layout="prev, pager, next"
        :isPadding="true"
        :page.sync="queryInfo.pageNum"
        :limit.sync="queryInfo.pageSize"
        :total="total"
        @pagination="handleSizeChange"
      ></Pagination>
    </div>
  </div>
</template>

<script>
import { infoManageApi } from "@/api/website";
import Pagination from "@/components/Pagination.vue";
import EmptyPage from "@/components/EmptyPage.vue";
export default {
  name: "newsDetail",
  props: {},
  components: {
    EmptyPage,
    Pagination,
  },
  data() {
    return {
      productType: "AIRoad",
      total: 0,
      queryInfo: {
        pageSize: 10,
        pageNum: 1,
      },
      dataList: [],
      categoryList: [],
      categoryId: "",
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.productType = this.$route.query.anchor;
    this.categoryId = this.$route.query.categoryId;
    this.getSkillList();
  },
  methods: {
    openUrl(item) {
      this.$uniFun.openInCurrentTab(
        `/academy/articleDetail?&id=${item.id}&categoryId=${this.categoryId}&anchor=${this.productType}&page=${this.queryInfo.pageNum}`,
      );
    },
    back() {
      this.$uniFun.openInCurrentTab(`/academy?&anchor=${this.productType}`);
    },

    getSkillList() {
      if (!this.categoryId) {
        this.back();
        return false;
      }
      let params = {
        current: this.queryInfo.pageNum,
        size: this.queryInfo.pageSize,
        type: "3",
        "params[categoryId]": this.categoryId,
      };
      infoManageApi(params).then((res) => {
        if (res.code === 200 && res.success) {
          let nowTimeString = this.$uniFun.getNowTime();
          let temp = res.data.records.filter(
            (item) =>
              nowTimeString > item.effectiveTime && item.startupStatus === "2",
          ); // 查找出已启用且生效的数据

          this.dataList = temp.map((item) => {
            let ext1Obj = JSON.parse(item.ext1);
            const labelsStr = ext1Obj.categorySelects
              ? ext1Obj.categorySelects.map((item) => item.label).join(",")
              : "";
            const coverUrl =
              item.coverUrlIdList.length > 0 ? item.coverUrlIdList[0].path : "";
            return {
              ...item,
              categoryId: ext1Obj.categoryId,
              categoryName: labelsStr,
              coverUrl: coverUrl,
              publishDate: item.effectiveTime.substring(0, 10),
            };
          });
          this.total = res.data.total;
        }
      });
    },
    handleSizeChange(e) {
      this.queryInfo.pageNum = e.pageIndex;
      this.getSkillList();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/common.scss";
.advanced-techniques-list {
  background: white;
  padding-bottom: 38px;
  .advanced-techniques-list-hd {
    width: 100%;
    height: 320px;
    background: url("~@/assets/images/academy/academy-hd_bg.png") no-repeat
      center;
    background-size: cover;
    .academy-hd-wrapper {
      width: 1049px;
      padding-top: 70px;
      margin: 0 auto;
    }
    .academy-hd-title {
      margin-bottom: 20px;
      font-weight: bold;
      font-size: 28px;
      color: #ffffff;
      line-height: 28px;
      font-style: normal;
    }
    .academy-hd-subTitle {
      margin-bottom: 20px;
      font-weight: 400;
      font-size: 18px;
      color: #ffffff;
      opacity: 0.8;
      line-height: 24px;
      font-style: normal;
    }
  }
  .topTitle {
    width: 100%;
    height: 64px;
    margin: 0 auto;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
    text-align: left;
    border-bottom: 1px solid #d8d8d8;
    position: sticky;
    top: 80px;
    background: #fff;
    z-index: 20;
    > div {
      width: 1049px;
      margin: 0 auto;
      > div {
        height: 64px;
        line-height: 64px;
      }
      .skillTitle {
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  .backBtn {
    cursor: pointer;
    line-height: 64px;
  }
  .backBtn:hover {
    color: #0035fb;
    border-bottom: 2px solid #0035fb;
  }

  .content {
    width: 1049px;
    margin: 0 auto;
    padding: 40px 0;
    display: flex;
    flex-wrap: wrap; /* 允许换行 */
    gap: 44px; /* 卡片之间的间距 */
    justify-content: space-between; /* 水平方向平均分布 */
    .advancedTechniquesList {
      width: fit-content;
      margin: 0 auto;
      height: fit-content;
      display: flex;
      flex-direction: column;
      gap: 40px;
      padding: 40px 0;

      .advancedTechniquesCard {
        width: 100%;
        height: 220px;
        border-bottom: 1px solid #eeeeee;
        display: flex;
        gap: 24px;
        cursor: pointer;
        .left {
          width: 40px;
          color: #999999;
          text-align: right;
          .date {
            font-size: 14px;
            line-height: 14px;
            font-weight: 600;
            margin-top: 20px;
          }
          .year {
            font-size: 12px;
            line-height: 12px;
            font-weight: 400;
          }
        }
        .line {
          width: 24px;
          height: 1px;
          background: #d9d9d9;
          margin-top: 28px;
        }

        .text {
          padding: 16px 0;
          width: 617px;
          .title {
            margin-bottom: 16px;
            @extend .text-truncate-multiline;
            --line-clamp: 2;
            width: 100%;
            // height: 48px;
            font-weight: 500;
            font-size: 18px;
            color: #333333;
            line-height: 24px;
            text-align: left;
          }

          .summary {
            width: 100%;
            height: auto;
            font-weight: 400;
            font-size: 12px;
            color: #666666;
            line-height: 20px;
            text-align: justify;
            @extend .text-truncate-multiline;
            --line-clamp: 7;
            // text-indent: 2em;
          }
        }

        .thumbnail {
          width: 320px;
          height: 180px;
          transition: all 0.3s ease-in-out;
        }
        &:hover {
          .thumbnail {
            transform: scale(1.05);
          }
          .title {
            color: #0035fb;
          }
        }
      }
    }
  }
}
</style>
